import React, { useState, useEffect, Fragment } from "react";
import { Container, Spinner, Row, Col, Accordion} from "react-bootstrap";
import { useParams } from "react-router-dom";
import ProblemService from "../services/problem.service";
import Problem from "../components/Problem";

const ProblemList = () => {

   const { problemtypeid } = useParams();
   const [problems, setProblems] = useState([]);
   const [loading, setLoading] = useState([]);
   const [errorMsg, setErrorMsg] = useState("");

   useEffect(() => { 
      const loadProblems = async (pbtypeid) => { 
        try{
          setLoading(true); 
          const response = await ProblemService.getProblems(pbtypeid);
          setProblems(response.data); 
          setLoading(false); 
        }
        catch(error){
          setLoading(false);
          setErrorMsg('Oops! Something went wrong');
        }
      }
      loadProblems(problemtypeid);
    }, []);  


    if (loading) {
      return (
        <Container>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Container>
      );
    }

    if (errorMsg){
      return (
        <Container>
          
            <span className="text-danger">{errorMsg}</span>
         
        </Container>
      );

    }

    const pbimgsrc = `/images/challenges/${problems[0].problemtypename}.png`;
   

    return( 
      <Fragment>

         <div className="bg-light mx-0 my-0 p-5 rounded-lg">
          <Row>
            <Col className="col-md-3">
               <img className="img-fluid"
                     src={pbimgsrc}
                     height="100%"
                     width = "100%"
                     alt="Project"
               />
            </Col>
            <Col className="col-md-9 ps-0 pt-3">
            <h1 className="display-3"> 
               {problems[0].problemtypename}
            </h1>
            <p> {problems[0].problemtypedesc} </p>
            </Col>
         </Row>
        </div> 

        <Container className = "mt-5 mb-5">
         <Accordion>
         {
                       problems.map((item) => (    
                           <Problem problem={item}/> 
                       )) 

        }
         </Accordion>
          
        </Container>

      </Fragment>
 
        
    );
};
  
  export default ProblemList;